export type AcfrStatus =
  | 'pending'
  | 'fetched'
  | 'extracted'
  | 'failed'
  | 'needs_review'
  | 'reviewed'
  | 'no_employer_table';

export type GeocodeStatus = 'found' | 'approximate' | 'not_found' | 'manual';

export interface AcfrReport {
  id: number;
  countyFips: string;
  state: string;
  countyName: string | null;
  issuerName: string | null;
  fiscalYear: number | null;
  status: AcfrStatus;
  source: 'found' | 'uploaded';
  sourceUrl: string | null;
  reviewReasons: string[];
  schedulePages: number[];
  pdfUrl: string | null;
  reviewedAt: string | null;
  reviewedBy: string | null;
  updatedAt: string;
  path: string;
}

export interface PrincipalEmployer {
  id: number;
  year: number;
  rank: number | null;
  name: string;
  employees: number | null;
  pctTotalEmployment: number | null;
  geocodeStatus: GeocodeStatus | null;
  latitude: number | null;
  longitude: number | null;
  editedBy: string | null;
  editedAt: string | null;
}

export interface ReportData {
  report: AcfrReport;
  employers: PrincipalEmployer[];
}

export const STATUS_LABELS: Record<AcfrStatus, string> = {
  pending: 'Pending',
  fetched: 'Extracting',
  extracted: 'Ready for review',
  failed: 'Failed',
  needs_review: 'Needs review',
  reviewed: 'Reviewed',
  no_employer_table: 'No employer table',
};
